import { z } from "zod";

import type { ZodError } from "zod";

/**
 *
 * @description ホテル向け領収書用のバリデーションスキーマ
 *
 * PaymentCreditInputSchema は、hotelID, paymentToken を受け取る。
 * paymentToken は Payjp の element で生成されたトークンを受け取る。
 *
 * @todo Payjp の element に合わせて実装する
 */
export const PaymentCreditInputZodSchema = z.object({ hotelID: z.string(), hasPayjpValidation: z.boolean() });

export type PaymentCreditInputZodSchemaType = z.infer<typeof PaymentCreditInputZodSchema>;

export type PaymentCreditInputZodParseError = ZodError<PaymentCreditInputZodSchemaType>;

/**
 * @description ReceiptInput のベーススキーマ
 */
const ReceiptSettingInputSchema = z.object({
	hotelID: z.string(),
});

/**
 * @description 宛名のバリデーションスキーマ
 */
export const ReceiptSettingInputZodSchema = ReceiptSettingInputSchema.extend({
	addressee: z.string().min(1, "宛名は必須項目です").max(50, "宛名は50文字以内で入力してください"),
});

export type ReceiptSettingInputZodSchemaType = z.infer<typeof ReceiptSettingInputZodSchema>;
